<template>
  <div :class="classObj" class="app-wrapper">
    <template
      v-if="
        $route.path === '/administrationOA/formProcessDesign' ||
          $route.path === '/administrationOA/mbInitiateProcess' ||
          $route.fullPath.indexOf('type=app') >= 0
      "
    >
      <!-- <navbar /> -->
      <!-- <tags-view /> -->
      <app-main style="height: calc(100vh);padding:0; overflow: auto;" />
    </template>

    <template v-else>
      <!-- 左侧导航 -->
      <div
        v-if="device === 'mobile' && sidebar.opened"
        class="drawer-bg"
        @click="handleClickOutside"
      ></div>
      <sidebar class="sidebar-container" />
      <!-- 右侧 -->
      <div class="main-container">
        <comprehenOperateScreenFrame
          v-if="$route.fullPath === '/equipSafeMan/comprehenOperateScreenFrame'"
        />
        <dataCenterBigScreen
          v-if="$route.fullPath === '/dataCenter/bigScreen'"
        />
        <dataCenterScreen
          v-if="$route.fullPath === '/dataCenter/dataCenterScreen'"
        />
        

        <comprehenOperateMonitorFrame
          v-else-if="
            $route.fullPath === '/equipSafeMan/comprehenOperateMonitorFrame'
          "
        />
        <comprehenOperateMonitor
          v-else-if="
            $route.fullPath === '/equipSafeMan/comprehenOperateMonitor'
          "
        />
        <comprehenOperateMonitorEryuan
          v-else-if="
            $route.fullPath === '/equipSafeMan/comprehenOperateMonitorEryuan'
          "
        />
        <detectionPlatform
          v-else-if="
            $route.fullPath === '/energyMonitoring/detectionPlatform'
          "
        />
        <comprehenOperateMonitorElevator
          v-else-if="
            $route.fullPath === '/equipSafeMan/comprehenOperateMonitorElevator'
          "
        />
        

        <energyMonitor
          v-else-if="$route.fullPath === '/energyMan/energyMonitor'"
        />

        <realTimeMonitoringScreen
          v-else-if="
            $route.fullPath === '/liftMan/realTimeMonitoringScreen'
          "
        />

        <template
          v-else-if="
            $route.fullPath === '/processMan/processSet' ||
              $route.fullPath === '/disinfectRouter/summaryStats'||
              $route.fullPath === '/liftMan/alarmAnalysis'
          "
        >
          <navbar />
          <tags-view />
          <app-main style="height: calc(100% - 84px)" />
        </template>

        <template v-else>
          <navbar />
          <tags-view />
          <app-main
            :style="
              `height:${
                isShowBottom ? 'calc(100% - 164px)' : 'calc(100% - 84px)'
              }`
            "
          />
          <div v-if="isShowBottom" class="footer-container">
            Copyright © 2025 维舟云版权所有
            <a
              target="_blank"
              href="https://beian.miit.gov.cn/#/Integrated/index"
              class="link-type"
              >黑ICP备2026005973号</a
            >

            
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Navbar, Sidebar, AppMain, TagsView } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import dataCenterBigScreen from "@/views/equipSafeMan/bigScreen/index";
import dataCenterScreen from "@/views/dataCenter/dataCenterScreen";
import comprehenOperateScreenFrame from "@/views/equipSafeMan/comprehenOperateScreenFrame";
import comprehenOperateMonitorFrame from "@/views/equipSafeMan/comprehenOperateMonitorFrame";
comprehenOperateScreenFrame;
import comprehenOperateMonitor from "@/views/equipSafeMan/comprehenOperateMonitor";
import comprehenOperateMonitorEryuan from "@/views/equipSafeMan/comprehenOperateMonitorEryuan";
import detectionPlatform from "@/views/energyMonitoring/detectionPlatform";
import comprehenOperateMonitorElevator from "@/views/equipSafeMan/comprehenOperateMonitorElevator";

import realTimeMonitoringScreen from "@/views/leftMan/realTimeMonitoringScreen";

import energyMonitor from "@/views/energyMan/energyMonitor";
import equipMixins from "@/views/equipSafeMan/equipMixins.js";

export default {
  name: "Layout",

  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView,
    comprehenOperateScreenFrame,
    dataCenterBigScreen,
    dataCenterScreen,
    comprehenOperateMonitorFrame,
    comprehenOperateMonitor,
    comprehenOperateMonitorEryuan,
    comprehenOperateMonitorElevator,
    detectionPlatform,//能源监控能耗监测大屏
    energyMonitor,
    realTimeMonitoringScreen
  },

  data() {
    return {
      userRoles: JSON.parse(decodeURI(window.localStorage.userRoles)),
      // 不显示底部白名单
      noBottomNavList: [
        "/heatMan/runMonitoring", //
        "/reportMan/statisticalAnalysis",
        "/matterMan/statisticalAnalysisNew",

        "/qualitySystem/statisticalAnalysis",
      ],
      routerPath: "",
      isShowBottom: true,
      notificationInstances: [] // 存储通知实例
    };
  },

  watch: {
    $route: {
      handler(val) {
        console.log(val);
        let fullPath = val.fullPath;
        console.log("----", this.noBottomNavList.indexOf(fullPath));
        if (this.noBottomNavList.indexOf(fullPath) >= 0) {
          this.isShowBottom = false;
        } else {
          this.isShowBottom = true;
        }
      },
      immediate: true
    }
  },

  mixins: [ResizeMixin, equipMixins],

  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile"
      };
    }
  },
  destroyed() {
    // 组件销毁时，清除所有通知实例
    this.clearAllNotifications();
  },
  mounted() {
    // 注册通知回调函数
    this.$store.dispatch('noticeBoard/setNotificationCallback', () => {
      this.showUnreadNoticeNotification();
    });

    window.onresize = () => {
      // 利用屏幕分辨率和window对象的内高度来判断兼容IE
      let winFlag = window.innerHeight === window.screen.height;
      // 利用window全屏标识来判断 -- IE无效
      let isFull = window.fullScreen || document.webkitIsFullScreen;

      let isFullscreen;
      if (isFull === undefined) {
        isFullscreen = winFlag;
      } else {
        isFullscreen = winFlag || isFull;
      }
      if (isFullscreen) {
        this.$store.dispatch("closeSideBar", { withoutAnimation: false });
      } else {
        this.$store.dispatch("openSideBar", { withoutAnimation: false });
      }
    };
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("closeSideBar", { withoutAnimation: false });
    },

    /**
     * 显示未读公告通知
     */
    showUnreadNoticeNotification() {
      // 先清除所有旧的通知
      this.clearAllNotifications();

      const { promotionUnread, meetingUnread, activityUnread } = this.$store.state.noticeBoard;
      const total = promotionUnread + meetingUnread + activityUnread;

      // 如果没有未读公告，不显示通知
      if (total === 0) {
        return;
      }

      // 构建通知内容和对应的跳转路由
      const noticeTypes = [];

      if (promotionUnread > 0 && this.userRoles.includes('pre_gonggaochakan')) {
        noticeTypes.push({
          name: '宣传公告',
          count: promotionUnread,
          path: '/safetyPrevention/noticeBoard/noticeView/promotion'
        });
      }
      if (meetingUnread > 0 && this.userRoles.includes('pre_gonggaochakan')) {
        noticeTypes.push({
          name: '会议公告',
          count: meetingUnread,
          path: '/safetyPrevention/noticeBoard/noticeView/meeting'
        });
      }
      if (activityUnread > 0 && this.userRoles.includes('pre_gonggaochakan')) {
        noticeTypes.push({
          name: '活动公告',
          count: activityUnread,
          path: '/safetyPrevention/noticeBoard/noticeView/activity'
        });
      }

      // 为每个未读公告类型显示一个通知
      noticeTypes.forEach((notice, index) => {
        setTimeout(() => {
          const instance = this.$notify({
            title: `${notice.name}提醒`,
            message: `您有 ${notice.count} 条未读${notice.name}`,
            type: 'info',
            duration: 0, // 不自动关闭
            position: 'top-right',
            onClick: () => {
              // 点击通知时跳转到对应的公告页面
              this.$router.push(notice.path);
            }
          });
          // 保存通知实例
          this.notificationInstances.push(instance);
        }, index * 300); // 错开显示时间，避免重叠
      });
    },

    /**
     * 清除所有通知
     */
    clearAllNotifications() {
      this.notificationInstances.forEach(instance => {
        instance.close();
      });
      this.notificationInstances = [];
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "~@/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.footer-container {
  height: 80px;
  line-height: 80px;
  text-align: center;
  color: #666666;
  background: #f5f5f5;
}
</style>
